<template>
  <div
    v-if="title"
    class="sb-modal-header"
    :class="{ 'sb-modal-header--left': isLeftAlignment }"
  >
    <slot name="icon">
      <SbIconCircle v-if="icon" :variant="iconVariant">
        <SbIcon :name="icon" />
      </SbIconCircle>
    </slot>
    <div class="sb-modal-header__heading">
      <h1 class="sb-modal-header__title">
        {{ title }}
      </h1>
      <slot name="heading" />
    </div>

    <div v-if="$slots.actions" class="sb-modal-header__actions">
      <slot name="actions" />
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import SbIcon from '../../Icon'
import SbIconCircle from '../../IconCircle'
import type { IconCircleVariant } from '../../IconCircle'

export default {
  name: 'SbModalHeader',

  components: {
    SbIcon,
    SbIconCircle,
  },

  props: {
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'center',
    },
    iconVariant: {
      type: String as PropType<IconCircleVariant>,
      default: 'success',
    },
  },

  computed: {
    isLeftAlignment() {
      return this.align === 'left'
    },
  },
}
</script>
